export default __webpack_public_path__ + "static/media/DSC_0582.1024e690.jpg";